// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"BalloonNumberSlider_subTitle__3h4CO","balloonNumberSlider":"BalloonNumberSlider_balloonNumberSlider__2na1M","slider":"BalloonNumberSlider_slider__PsyIY"};